import Instense from "./Axios-config";

export class File {
  public static DownloadZip = async (req): Promise<any | null> => {
    const url = `/File/DownloadZip`;
    return Instense.get(url, {
      params: req,
      responseType:"blob",
      paramsSerializer: (params) => {
        // Convert array params to multiple key-value pairs like HIDs=1414&HIDs=1413...
        return Object.entries(params)
          .map(([key, value]) =>
            Array.isArray(value)
              ? value.map((v) => `${key}=${v}`).join("&")
              : `${key}=${value}`
          )
          .join("&");
      },
    }).then((response) => {
      return response.data || {};
    });
  };

  public static DownloadPayrollZip = async (req): Promise<any | null> => {
 

    const request: any = { ...req };
    const url = `/File/DownloadPayrollZip`;
    return Instense.get(url, {
      params: request,
      responseType:"blob",
      paramsSerializer: (params) => {
        // Convert array params to multiple key-value pairs like HIDs=1414&HIDs=1413...
        return Object.entries(params)
          .map(([key, value]) =>
            Array.isArray(value)
              ? value.map((v) => `${key}=${v}`).join("&")
              : `${key}=${value}`
          )
          .join("&");
      },
    }).then((response) => {
      return response.data || {};
    });
  };
}
